import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { dfdDefaultTheme, MuiBox, MuiCardMedia, MuiTypography } from 'theme/material-ui';
import {
  ConnectCareButton,
  ConnectCareCardActions,
  ConnectCareCardContent,
  ConnectCareCardHeader
} from 'components/ConnectCare';
import { Svg } from 'components/UI/Svg';
import { MuiHomeCard, ImgBox } from './styled';
import { HIDE_IMAGE_BREAKPOINT } from 'modules/constants/ConnectCare';
import { Color } from 'shared/src/modules/styles/colors';

import styled from 'styled-components';

const ConnectCareLink = styled(ConnectCareButton)`
  &.MuiButton-root {
    color: ${Color.blueHue8};
  }
`;

const StyledMuiCardMedia = styled(MuiCardMedia)`
  &.MuiCardMedia-root {
    width: 265px;
  }
`;

const StyledMuiBox = styled(MuiBox)`
  &.MuiBox-root {
    ${dfdDefaultTheme.breakpoints.down('lg')} {
      padding: 24px 24px 8px;
    }
  }
`;

export interface CardSectionProps {
  buttonLabel: string;
  color: string;
  description: string;
  imgSrc: string;
  linkLabel: string;
  testId: string;
  title: string;
  connectCareTypeClick: () => void;
  linkHandlerClick: () => void;
}

const getImage = (color: string, imgSrc: string, isSmallScreen: boolean) => {
  if (isSmallScreen) {
    return null;
  }
  return (
    <ImgBox>
      <MuiBox bgcolor={color} width="10px" />
      {imgSrc ? (
        <StyledMuiCardMedia component="img" src={imgSrc} data-testid="section-image" />
      ) : (
        <Svg set="assets" name="ConnectCareLogo" width={250} height="100%" />
      )}
    </ImgBox>
  );
};

export const ConnectCareSection = ({
  buttonLabel,
  color,
  description,
  imgSrc,
  linkLabel,
  testId,
  title,
  connectCareTypeClick,
  linkHandlerClick
}: CardSectionProps) => {
  const isSmallScreen = useMediaQuery(dfdDefaultTheme.breakpoints.down(HIDE_IMAGE_BREAKPOINT));
  return (
    <MuiBox my={3} data-testid={testId}>
      {isSmallScreen ? <MuiBox bgcolor={color} height="10px" /> : null}
      <MuiHomeCard>
        {getImage(color, imgSrc, isSmallScreen)}
        <StyledMuiBox py={3} px={4}>
          <ConnectCareCardHeader title={title} />
          <ConnectCareCardContent>
            <MuiTypography color="textPrimary" data-testid="section-description">
              {description}
            </MuiTypography>
          </ConnectCareCardContent>
          <ConnectCareCardActions>
            <ConnectCareButton fullWidth size="large" onClick={connectCareTypeClick}>
              {buttonLabel}
            </ConnectCareButton>
            <ConnectCareLink fullWidth size="large" variant="text" onClick={linkHandlerClick}>
              {linkLabel}
            </ConnectCareLink>
          </ConnectCareCardActions>
        </StyledMuiBox>
      </MuiHomeCard>
    </MuiBox>
  );
};
